import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Chip from "../../components/Chip/Chip";
import MaterialIcons from "../../components/MaterialIcons";
import navLinks, { getRouteTitle } from "../../utils/navigation";
import "./applications.scss";
import "../Admin/admin.scss";
import Masonry, { MasonryBox } from "../../Layout/Masonry/Masonry";
// import applications from "../../utils/applications";
import Application from "./Application";
import { adminBg, mug404 } from "../../utils/images";
import GlobalContext from "../../context/GlobalContext";

const Applications = () => {
	const location = useLocation();
	const { applications, getAllApplications } = useContext(GlobalContext);
	const [openNav, setOpenNav] = useState(false);
	useEffect(() => {
		setOpenNav(false);
	}, [location.pathname]);
	useEffect(() => {
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape") setOpenNav(false);
		});
		return () => {
			document.removeEventListener("keydown", (e) => {
				if (e.key === "Escape") setOpenNav(false);
			});
		};
	}, []);
	const [ALL, NOT_REVIEWED, APPROVED, DECLINED] = [0, 1, 2, 3];
	const tabs = [
		{
			title: "All",
			icon: "group",
			color: "indigo",
			id: ALL,
		},
		{
			title: "Not Reviewed",
			icon: "mark_email_unread",
			color: "purple",
			id: NOT_REVIEWED,
		},
		{
			title: "Approved",
			icon: "mark_email_read",
			color: "green",
			id: APPROVED,
		},
		{
			title: "Declined",
			icon: "unsubscribe",
			color: "red",
			id: DECLINED,
		},
	];
	const [activeTab, setActiveTab] = useState(ALL);
	const checkStatus = (application, tab) => {
		switch (tab) {
			case ALL:
				return true;
			case NOT_REVIEWED:
				return !application.reviewed;
			case APPROVED:
				return application.reviewed && application.approved;
			case DECLINED:
				return application.reviewed && !application.approved;
			default:
				return true;
		}
	};
	useEffect(() => {
		getAllApplications();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<main
			className="applications"
			style={{
				backgroundImage: `url(${adminBg})`,
			}}
		>
			<section className="header admin-header">
				<div
					className="header-current"
					onClick={() => setOpenNav((p) => !p)}
				>
					<span className="header-current-route">
						{getRouteTitle(location.pathname)}
					</span>
					<MaterialIcons>unfold_more</MaterialIcons>
				</div>
				<div
					className={`header-routes-list ${
						openNav && "header-routes-list-active"
					}`}
				>
					{navLinks.map(({ icon, route, text }, index) => (
						<Link key={index} to={route} className="header-route">
							{icon}
							{text}
						</Link>
					))}
				</div>
			</section>
			<section className="applications-head">
				<h1>Applications</h1>
			</section>
			<section className="applications-head">
				{tabs.map((tab, index) => (
					<Chip
						key={index}
						icon={tab.icon}
						text={tab.title}
						style={{
							backgroundColor: `var(--${tab.color}-${
								activeTab === tab.id ? 700 : 100
							})`,
							color:
								activeTab === tab.id
									? "var(--white)"
									: `var(--${tab.color}-700)`,
							border: `2px solid var(--${tab.color - 700})`,
						}}
						onClick={() => setActiveTab(() => tab.id)}
					/>
				))}
			</section>
			<section className="applications-body">
				{applications.length > 0 ? (
					<Masonry>
						{applications?.map(
							(application, index) =>
								checkStatus(application, activeTab) && (
									<MasonryBox
										lg={3}
										md={2}
										sm={1}
										key={index}
									>
										<Application {...application} />
									</MasonryBox>
								)
						)}
					</Masonry>
				) : (
					<div className="null">
						<div className="null-image">
							<img src={mug404} alt="Broken Mug" />
						</div>
						<div className="null-text">
							<h2>Nothing to see here</h2>
						</div>
					</div>
				)}
			</section>
		</main>
	);
};

export default Applications;
